import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const SubscriptionTable = ({
    data,
    rows,
    rowsPerPageOptions,
    columns
}) => {
    return <div id='subscriptionTable' style={{ position: "relative" }}>
    {data.length === 0 ? (
      <div className='drag-description'>No data to show</div>
    ) : (
        <DataTable
          className='p-datatable-striped'
          value={data}
          size="large"
          paginator
          paginatorTemplate='CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'
          currentPageReportTemplate='Showing {first} to {last} of {totalRecords}'
          rows={rows}
          rowsPerPageOptions={rowsPerPageOptions}
          showGridlines={true}
        >
          {columns.map((col) => (
            <Column key={col.field} field={col.field} header={col.header} body={col.body} />
          ))}
        </DataTable>
    )}
  </div>
}

export default SubscriptionTable;